import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import LucianaNahuel from "../../assets/Luciana1.jpg";
import gentecurso from "../../assets/gentecurso/gentecurso2.jpg";

const CoursePriceInfo = () => {
  // WhatsApp con mensaje automático
  const phoneNumber = "5492235453354";
  const message =
    "Hola Lu, te hablo desde tu página web. ¡Quiero inscribirme en tu curso!";
  const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
    message
  )}`;

  return (
    <section
      id="precio"
      className="relative py-16 px-4 sm:px-8 md:px-12 text-[#2c2c2c] font-serif overflow-hidden"
    >
      {/* Imagen de fondo */}
      <img
        src={gentecurso}
        alt="Decoración curso"
        className="absolute inset-0 w-full h-full object-cover opacity-30 pointer-events-none"
        style={{ zIndex: 1 }}
      />

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative z-10 mx-auto w-full max-w-4xl bg-white/90 backdrop-blur-md rounded-3xl shadow-xl px-6 sm:px-10 py-12"
      >
        {/* Imagen flotante */}
        <div className="absolute -top-12 left-6 sm:left-10 w-24 h-24 sm:w-28 sm:h-28 rounded-full border-4 border-white shadow-md overflow-hidden">
          <img
            src={LucianaNahuel}
            alt="Luciana y Nahuel"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Contenido principal */}
        <div className="pl-0 sm:pl-40">
          <h2 className="text-3xl sm:text-4xl font-extrabold mb-6 text-[#2c2c2c]">
            Valor del curso
          </h2>

          {/* Precios */}
          <div className="space-y-3 text-base sm:text-lg text-[#2c2c2c]">
            <p>
              <span className="font-bold">• Precio:</span>{" "}
              <span className="font-bold text-[#2c2c2c]">300 USD</span>{" "}
              <span className="ml-1 text-base font-normal">
                incluye todos los materiales necesarios.
              </span>
            </p>
            <p>
              <span className="font-bold">• Duración:</span>{" "}
              <span className="italic font-semibold text-[#2c2c2c]">
                3 días de 7 horas cada uno.
              </span>
            </p>
          </div>

          {/* Condiciones */}
          <ul className="mt-6 space-y-3 text-sm sm:text-base text-[#3b2f2a]">
            <li>
              <FaCheckCircle className="inline mr-2 text-green-600" />
              Se reserva con el <span className="font-bold">50%</span>.
            </li>
            <li>
              <FaCheckCircle className="inline mr-2 text-green-600" />
              El restante se abona <span className="font-bold">antes del inicio</span>.
            </li>
          </ul>

          {/* Cupos */}
          <p className="italic font-semibold mt-6 text-sm sm:text-base text-[#2c2c2c]">
            Cupos limitados: 8 personas por curso.
          </p>

          {/* CTA → WhatsApp */}
          <div className="mt-10 flex justify-center">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 border-2 border-[#9f7042] text-[#9f7042] rounded-full font-semibold hover:bg-[#9f7042] hover:text-white transition"
            >
              Quiero ser parte
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default CoursePriceInfo;
